/* ============================================================
   pdp-feeding.js — SHOGUN PDP 給餌計算機 (チップ選択式)
   出典: pdp-mock-template.html <script> 給餌計算部の逐語移植
   TABLE = Animal One 公式給与表 (g/day)。PRICE/PACK は data 属性から
   (¥10,000 ハードコード禁止 — product.price が単一ソース)
   ============================================================ */
(function () {
  'use strict';

  /* Animal One 公式給与量表と全セル照合済み (2026-07-20・6kg/8kg列の補間誤差を修正)
     再照合 2026-08-30: OEM公式ページ (animal-one.co.jp dog-drytype-basic-adult-2) の
     一日給与量目安と全32セル一致を確認 — puppy=成長期②(4-9ヶ月)/adult=1〜2歳/mature=3〜6歳/senior=7歳以上 (CHG-085) */
  var TABLE = {
    puppy:  { 2: 82, 4: 138, 6: 187, 8: 232, 10: 274, 15: 372, 20: 462, 25: 546 },
    adult:  { 2: 61, 4: 103, 6: 139, 8: 172, 10: 204, 15: 276, 20: 343, 25: 405 },
    mature: { 2: 52, 4: 87,  6: 118, 8: 146, 10: 173, 15: 234, 20: 290, 25: 343 },
    senior: { 2: 45, 4: 75,  6: 102, 8: 126, 10: 149, 15: 202, 20: 251, 25: 296 }
  };

  function init() {
    var calc = document.querySelector('[data-pdp-feeding]');
    if (!calc || calc.dataset.pdpFeedingInit) return;
    calc.dataset.pdpFeedingInit = '1';

    /* per-day 金額表記はカーンFB 2026-07-23 で全面廃止 — 「1袋≈何日分」+ 1ヶ月分購入導線のみ */
    var PACK = parseInt(calc.getAttribute('data-pack'), 10) || 800;
    /* CHG-085: 初期状態は Liquid (schema 設定) から data- 属性経由で受け取る — 二重管理の排除 */
    var kg = parseFloat(calc.getAttribute('data-initial-kg')) || 4;
    var st = calc.getAttribute('data-initial-stage') || 'mature';
    if (!TABLE[st] || !TABLE[st][kg]) { kg = 4; st = 'mature'; }
    /* Liquid 側の .act と解決後の初期値を一本化 (表外設定値でも必ず1チップが選択状態になる) */
    calc.querySelectorAll('[data-wchips] button').forEach(function (b) {
      b.classList.toggle('act', parseFloat(b.getAttribute('data-kg')) === kg);
    });
    calc.querySelectorAll('[data-stage] button').forEach(function (b) {
      b.classList.toggle('act', b.getAttribute('data-st') === st);
    });
    var gramsEl = calc.querySelector('[data-grams]');
    var costEl = calc.querySelector('[data-cost]');

    function render() {
      var g = TABLE[st][kg];
      var days = PACK / g;
      gramsEl.textContent = g;
      costEl.innerHTML = 'one ' + PACK + ' g pack ≈ <b>' + Math.floor(days) + '</b> days<small>2–4 meals a day</small>';
      /* 2026-09-24: 購入は 3 袋 (Buy 2, Get 1 Free) 固定。数量・文言は Liquid 側が正本で、ここは「3 袋で何日もつか」だけ更新 */
      var days3El = calc.querySelector('[data-calc-days3]');
      if (days3El) days3El.textContent = Math.floor((3 * PACK) / g);
    }

    /* a11y: 選択状態を aria-pressed でも表現 (視覚 .act と同期) */
    function syncPressed(group) {
      calc.querySelectorAll(group + ' button').forEach(function (x) {
        x.setAttribute('aria-pressed', x.classList.contains('act') ? 'true' : 'false');
      });
    }
    calc.querySelectorAll('[data-wchips] button').forEach(function (b) {
      b.addEventListener('click', function () {
        calc.querySelectorAll('[data-wchips] button').forEach(function (x) { x.classList.remove('act'); });
        b.classList.add('act'); kg = +b.getAttribute('data-kg'); syncPressed('[data-wchips]'); render();
      });
    });
    calc.querySelectorAll('[data-stage] button').forEach(function (b) {
      b.addEventListener('click', function () {
        calc.querySelectorAll('[data-stage] button').forEach(function (x) { x.classList.remove('act'); });
        b.classList.add('act'); st = b.getAttribute('data-st'); syncPressed('[data-stage]'); render();
      });
    });
    syncPressed('[data-wchips]');
    syncPressed('[data-stage]');
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
